/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=7355f92e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=7355f92e&scoped=true&lang=css"

import exportComponent from "/root/workspace/company_D7jw/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.27_vue@3.5.27_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7355f92e"]])

export default __exports__